var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({backgroundColor: _vm.bgColor})},[_c('h3',{staticClass:"center"},[_c('div',[_vm._v("SLA:")]),(_vm.slaTime === -1)?_c('div',[_vm._v("keine")]):_c('div',[_c('HumanDate',{attrs:{"date":_vm.slaTime}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }